export default "__VITE_ASSET__BBjDJyDQ__"